import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ClassesCTA() {
  return <section className="py-20 px-4 bg-gray-50" data-id="element-326">
      <div className="max-w-4xl mx-auto text-center" data-id="element-327">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-328">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0f1f3d] mb-6" data-id="element-329">
            Ready to Find Your Perfect Program?
          </h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-330">
            Whether you're just starting out or training for competition, we
            have a program designed for your goals. Try any class for 2 weeks
            and see which one is right for you.
          </p>
          <Link to="/" className="inline-block px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-331">
            Start Your $29 Trial
          </Link>
        </motion.div>
      </div>
    </section>;
}